<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip right>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            small
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Passport History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      title="Passport Histories"
      text="List of Passport Records"
      class="mb-0"
    > 
      <v-skeleton-loader
        v-if="loading"
        type="list-item"
      />
      <v-data-table
        v-else
        :headers="headers"
        :items="identityDocumentHistoriesRecords"
        disable-pagination
        hide-default-footer
        dense
        class="mt-5 mb-0"
        :style="`border:1px solid rgba(0,0,0,.12)`"
      >
        <template v-slot:item.issue_date="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.issue_date ? $moment(item.issue_date).format('D MMM YYYY') : 'N/A' }}
            </span>
          </div>
        </template>

        <template v-slot:item.expiry_date="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.expiry_date ? $moment(item.expiry_date).format('D MMM YYYY') : 'N/A' }}
            </span>
          </div>
        </template>

        <template 
          v-slot:item.action="{ item }"
        >
          <div>
            <employee-profile-general-info-personal-detail-dialog-edit-identity-document-histories
              v-if="item.index !== 0"
              :identity-document-history="item"
              :min-issue-date="!(item.index === identityDocumentHistoriesRecords.length - 1) ? $moment(identityDocumentHistoriesRecords[item.index + 1].expiry_date).format('YYYY-MM-DD') : ''"
              :max-expiry-date="item.index > 0 ? $moment(identityDocumentHistories[item.index - 1].issue_date).format('YYYY-MM-DD') : ''"
              @updated="$emit('updated'); dialog = false"
            />
          </div>
        </template>
      </v-data-table>
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    components: {
      EmployeeProfileGeneralInfoPersonalDetailDialogEditIdentityDocumentHistories: () => import('@/components/hris/employee/profile/general-info/personal-detail/DialogEditIdentityDocumentHistories'),
    },
    props: {
      identityDocumentHistories: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headers: [
          {
            text: 'Passport Number', 
            sortable: false, 
            value: 'identity_number',
            divider: true,
          },
          {
            text: 'Issue Date',
            sortable: false,
            value: 'issue_date',
            divider: true,
            align: 'center',
          },
          {
            text: 'Expiry Date', 
            sortable: false, 
            value: 'expiry_date',
            divider: true,
            align: 'center',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
            align: 'center',
          },
        ],
      }
    },
    computed: {
      identityDocumentHistoriesRecords () {
        return this.identityDocumentHistories.map((item, index) => ({
          index: index,
          ...item,
        }))
      },
    },
  }
</script>
